var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTheoriq = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 143,
    viewBox: "0 0 294 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.797 81.4444H248.692C246.963 82.789 244.898 83.8934 242.401 83.8934C236.974 83.8934 232.988 79.5235 232.988 73.3288C232.988 66.0776 239.039 61.3235 245.09 61.3235C247.155 61.3235 249.22 61.8037 250.853 62.476L254.023 60.6992V77.57H254.024V87.8658L258.73 90.0747L254.306 91.6921L249.798 93.3402L249.798 81.4444H249.797ZM249.797 65.8855V79.0913C249.22 80.0998 247.492 81.0602 245.571 81.0602C240.96 81.0602 237.551 77.7467 237.551 72.1283C237.551 65.9335 241.008 63.3404 244.85 63.3404C247.203 63.3404 249.172 64.4449 249.797 65.8855Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.671 54.8067L129.965 52.5976L138.898 49.332V65.103H140.002C141.683 63.4702 143.892 61.4532 147.11 61.4532C151.048 61.4532 152.873 64.3346 152.873 68.5126V81.623H156.331V83.5439H145.189V81.623H148.647V69.7132C148.647 66.4957 146.918 64.8149 143.94 64.8149C141.971 64.8149 140.146 66.1595 138.898 67.3601V81.623H142.356V83.5439H131.214V81.623H134.671V54.8067Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.582 55.0103C223.582 56.5951 224.879 57.8917 226.512 57.8917C228.144 57.8917 229.441 56.5951 229.441 55.0103C229.441 53.4255 228.144 52.1289 226.512 52.1289C224.879 52.1289 223.582 53.4255 223.582 55.0103Z",
    fill: "#F4F4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224.73 81.5523V66.8572L220.504 64.1679L228.956 60.9023V81.5523H232.414V83.4733H221.272V81.5523H224.73Z",
    fill: "#F4F4F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.121 66.8182L200.895 64.1289L209.347 60.8633V65.0893H210.356C212.565 63.0724 214.342 61.3435 216.407 61.3435C217.944 61.3435 219.144 62.4 219.144 63.9368C219.144 65.2334 218.184 66.386 216.887 66.9142L213.141 64.6571L209.347 67.4905V81.5133H214.246V83.4342H201.663V81.5133H205.121V66.8182Z",
    fill: "#F4F4F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.438 72.6175C178.438 65.9903 183.864 61.332 189.772 61.332C195.679 61.332 201.106 65.9903 201.106 72.6175C201.106 79.2447 195.679 83.903 189.772 83.903C183.864 83.903 178.438 79.2447 178.438 72.6175ZM183.096 72.6175C183.096 78.0921 186.266 82.0301 189.772 82.0301C193.277 82.0301 196.447 78.0921 196.447 72.6175C196.447 67.1428 193.277 63.2049 189.772 63.2049C186.266 63.2049 183.096 67.2389 183.096 72.6175Z",
    fill: "#F4F4F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.263 76.7475C174.447 81.5498 170.941 83.903 166.811 83.903C161.096 83.903 156.773 79.2447 156.773 72.8576C156.773 66.8547 161.432 61.332 167.099 61.332C172.382 61.332 175.552 65.462 175.552 70.3604H160.183C160.135 70.6485 160.135 70.9367 160.135 71.2728C160.135 76.5554 163.881 80.1091 168.3 80.1091C171.181 80.1091 173.438 79.1967 175.263 76.7475ZM166.379 63.6852C163.737 63.6852 161.336 65.414 160.471 68.5835H171.133C171.133 65.6061 169.212 63.6852 166.379 63.6852Z",
    fill: "#F4F4F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.681 62.4464H127.691L126.25 64.8476H120.681V76.1811C120.681 79.3986 122.506 80.6953 124.715 80.6953C126.54 80.6953 128.077 80.071 129.614 78.5822C128.461 82.0879 125.82 83.9128 122.506 83.9128C119.336 83.9128 116.43 81.8397 116.43 77.9498L116.43 76.0288V64.8476V62.4464V62.2754V58.3506L120.681 56.8008V62.4464Z",
    fill: "#F4F4F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6554 49.3438H91.2989V51.907H68.6554V49.3438Z",
    fill: "#F4F4F4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.157 49.3438H91.2989L91.2985 50.6254H45.157V49.3438Z",
    fill: "#F4F4F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8182 53.6163H96.6406V54.898H39.8182V53.6163Z",
    fill: "#F4F4F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6136 57.8889H99.8445V59.1706H36.6136V57.8889Z",
    fill: "#F4F4F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6226 66.4341H102.835V67.7157H33.6226V66.4341Z",
    fill: "#F4F4F4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6908 62.1615H101.767V63.4432H34.6908V62.1615Z",
    fill: "#F4F4F4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3143 53.6163H96.6406L96.6387 55.966H63.3143V53.6163Z",
    fill: "#F4F4F4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1119 57.8889H99.8445L99.8449 60.025H60.1119V57.8889Z",
    fill: "#F4F4F4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1892 62.1615H101.767L101.767 64.084H58.1892V62.1615Z",
    fill: "#F4F4F4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.121 66.4341H102.835L102.835 68.143H57.121V66.4341Z",
    fill: "#F4F4F4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1953 70.7067H103.262V71.9883H33.1953V70.7067Z",
    fill: "#F4F4F4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.157 92.0608H91.2985V93.3425H45.157V92.0608Z",
    fill: "#F4F4F4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8182 87.7971H96.6406V89.0787H39.8182V87.7971Z",
    fill: "#F4F4F4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6136 83.5245H99.8445V84.8061H36.6136V83.5245Z",
    fill: "#F4F4F4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6908 79.2519H101.767V80.5335H34.6908V79.2519Z",
    fill: "#F4F4F4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6226 74.9793H102.835V76.2609H33.6226V74.9793Z",
    fill: "#F4F4F4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6226 74.5476H79.3368V76.2565H33.6226V74.5476Z",
    fill: "#F4F4F4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6908 78.6088H78.2688V80.5312H34.6908V78.6088Z",
    fill: "#F4F4F4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6136 82.6699H76.3465V84.806L36.6136 84.8061V82.6699Z",
    fill: "#F4F4F4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8182 86.7223H73.1426V89.072H39.8182V86.7223Z",
    fill: "#F4F4F4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M45.157 90.7835H67.8005V93.3467H45.157V90.7835Z",
    fill: "#F4F4F4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTheoriq);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/theoriq.3cd4fba8df8a25422e4c68a71e7769e2.svg";